import React from 'react';
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Banner from '../Banner';
import { withInvitation } from '../../containers/withInvitation';
import AcceptInvitationButton from './AcceptInvitationButton';
import DenyInvitationButton from './DenyInvitationButton';


const styles = theme => ({
  button: {
    backgroundColor: 'white',
    color: 'black',
    marginLeft: 16,
  },
});

const InvitationBanner = ({
  acceptInvitation,
  denyInvitation,
  invitation,
  classes,
}) => (
  <Banner 
    actions={
      [
        <AcceptInvitationButton
          key="accept"
          color="default"
          variant="contained"
          invitation={invitation}
          handleAccept={acceptInvitation}
          className={classes.button}
        />
        ,
        <DenyInvitationButton
          key="deny"
          color="default"
          variant="contained"
          invitation={invitation}
          handleDeny={denyInvitation}
          className={classes.button}
        />
      ]
    }
  >
    <Typography>
      <FormattedMessage 
        id='subscription.banner.info.inviteToUse' 
        values={{
          productName: invitation.licence
          // FIXME: an invitation that has just been sent has no attached licence
          // hence no attached product
          ? invitation.licence.plan.product.name
          : '',
          ownerEmail: invitation.owner.email
        }}
      /> 
    </Typography>
  </Banner>
)

InvitationBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  invitation: PropTypes.object.isRequired,
  acceptInvitation: PropTypes.func.isRequired,
  denyInvitation: PropTypes.func.isRequired,
};

export default withStyles(styles)(
  withInvitation(InvitationBanner)
);


// WEBPACK FOOTER //
// ./src/components/invitations/InvitationBanner.js